import { createBrowserRouter } from 'react-router-dom'

import MainPage from '@/pages/MainPage'
import QuestionPage from '@/pages/QuestionPage'
import QuizPage from '@/pages/QuizPage'
import ResultPage from '@/pages/ResultPage'

import { Helmet } from './Helmet'
import NotFound404Page from '@/pages/NotFound404Page'

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Helmet
        title="Рекорды городов России - «Самые-самые» места в городах России"
        description="Рекорды городов России: удивительные здания, улицы и другие объекты в российских городах"
      >
        <MainPage />
      </Helmet>
    ),
  },
  {
    path: '/quiz',
    element: (
      <Helmet
        title="Кто здесь самый-самый? - 10 вопросов о разных рекордах городов"
        description="Прежде чем узнать, что и где в стране самое-самое, попробуйте угадать! Мы подготовили квиз на 10 вопросов о разных рекордах. Ваша задача — правильно выбрать город."
      >
        <QuizPage />
      </Helmet>
    ),
  },
  {
    path: '/questions',
    element: (
      <Helmet
        title="Кто здесь самый-самый? - 10 вопросов о разных рекордах городов"
        description="Прежде чем узнать, что и где в стране самое-самое, попробуйте угадать! Мы подготовили квиз на 10 вопросов о разных рекордах. Ваша задача — правильно выбрать город."
      >
        <QuestionPage />
      </Helmet>
    ),
  },
  {
    path: '/results/:id',
    element: (
      <Helmet
        title="Кто здесь самый-самый? - 10 вопросов о разных рекордах городов"
        description="Прежде чем узнать, что и где в стране самое-самое, попробуйте угадать! Мы подготовили квиз на 10 вопросов о разных рекордах. Ваша задача — правильно выбрать город."
      >
        <ResultPage />
      </Helmet>
    ),
  },
  {
    path: '*',
    element: (
      <Helmet
        title="Рекорды городов России - «Самые-самые» места в городах России"
        description="Рекорды городов России: удивительные здания, улицы и другие объекты в российских городах"
      >
        <NotFound404Page />
      </Helmet>
    ),
  },
])
